import {Component, EventEmitter, Input, Output, Signal, WritableSignal, inject, linkedSignal, signal} from '@angular/core';
import {DialogModule, TooltipModule} from "@syncfusion/ej2-angular-popups";
import {FormInputComponent} from "../../../shared/elements/form-input/form-input.component";
import {HeadlineComponent} from "../../../shared/elements/headline/headline.component";
import {TooltipComponent} from "../../../shared/elements/tooltip/tooltip.component";
import {TranslatePipe} from "../../../shared/pipes/translate.pipe";
import {DialogService} from "../../../shared/services/dialog.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {ListViewModule} from "@syncfusion/ej2-angular-lists";
import {LanguageService} from "../../../shared/services/language.service";
import {FormButtonComponent} from "../../../shared/elements/form-button/form-button.component";
import {AvatarComponent} from "../../../shared/elements/avatar/avatar.component";
import {CustomerService} from '../../../shared/services/customer.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {flagLink} from '../../../shared/mapper/language-flag-mapper';
import {ProfileService} from '../../../shared/services/profile.service';

@Component({
    selector: 'app-dialog-profile-language',
    imports: [
        DialogModule,
        FormInputComponent,
        HeadlineComponent,
        TooltipComponent,
        TranslatePipe,
        ListViewModule,
        TooltipModule,
        FormButtonComponent,
        AvatarComponent
    ],
    templateUrl: './dialog-profile-language.component.html',
    styleUrl: './dialog-profile-language.component.scss'
})
export class DialogProfileLanguageComponent {
  public dialogService: DialogService = inject(DialogService);
  private formBuilder: FormBuilder = inject(FormBuilder);
  private languageService: LanguageService = inject(LanguageService);
  private customerService: CustomerService = inject(CustomerService);
  private profileService: ProfileService = inject(ProfileService);

  @Input() public visible: boolean = false;
  @Output() public  visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public languages: Signal<string[]> = linkedSignal(() => {
    const availableLanguages = this.customerService.customerResource()?.languages ?? [];
    return availableLanguages.filter(language => this.languageService.getTranslationByKey(language).toLocaleLowerCase().includes(this.query().toLocaleLowerCase()));
  });
  public activeLanguage: WritableSignal<string> = signal(this.profileService.profile()?.user.language ?? this.languageService.getLanguage());
  public profileLanguageForm: FormGroup = this.formBuilder.group({
    searchString: [''],
  });
  private query: WritableSignal<string> = signal('');

  public constructor() {
    this.profileLanguageForm.get('searchString')?.valueChanges
    .pipe(takeUntilDestroyed())
    .subscribe((value: string) => {
      this.query.set(value);
    });
  }

  public selectLanguage(language: string): void {
    this.activeLanguage.set(language);
  }

  public close(): void {
    this.query.set('');
    this.visibleChange.emit(false);
  }

  public save(): void {
    this.languageService.setLanguage(this.activeLanguage());
    this.profileService.setProfileLanguage(this.activeLanguage());
    this.close();
  }

  public flagLink(language: string): string {
    return flagLink(language);
  }
}
